export default __webpack_public_path__ + "static/media/step_1_dont_2.e46caba4.jpg";